import { ChangeDetectionStrategy, Component } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";
import { SnackbarComponent } from "../snackbar.component";

@Component({
  selector: "app-success-message",
  imports: [TranslatePipe, MatIconModule],
  templateUrl: "./success-message.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./success-message.component.less",
})
export class SuccessMessageComponent extends SnackbarComponent<string> {
  public constructor() {
    super();
  }
}
